/** @jsx $mol_jsx */
/** @jsxFrag $mol_jsx_frag */
namespace $.$$ {
	$mol_jsx_view
	export class $shm_hitalama_map_widget_float_customdom extends $.$shm_hitalama_map_widget_float_customdom {
		fullsize_height() {
			return this.auto_height() && !this.fullscreen_attr() ? '' : '100%'
		}
		
		@ $mol_mem
		code( next?: string ): string {
			return this.widget().code( next ) ?? ''
		}

		customdom_content() {
			const res = this.result()
			return [ this.Dom_wrapper() ]
		}

		@ $mol_mem
		Dom_wrapper() {
			const res = this.result()

			if( this.error() ) return this.Error()

			if( res instanceof $mol_view ) {
				return res
			}
			if( res?.getAttribute?.('data-crus-ref') ) {
				return res
			}
			
			if( res instanceof Node ) {
				return this.$.$shm_hitalama_map_widget_view_dom.make({content:()=>res})
			}

			return this.Dump()
		}

		data?: any //cache, used in js, by this.view.data
		@ $mol_mem
		result() {
			return $mol_error_fence(
				()=> {
					const res = this.map().execute( this.code(), { [ '$' + 'page' ]: this.Map_page(), [ '$' + 'this_widget' ]: this.widget(), [ '$' + 'view' ]: this } )
					if( res instanceof $mol_view ) {
						try {
							res.render()
						} catch (error) {
							console.log('catcherror', error)
							throw error
						}
					}
					this.error('')
					return res
				},
				( error )=> {
					this.data = undefined
					console.log('error???', error)
					this.error( error.toString() )
				}
			)
		}

		skip_drag( el: Element ) {
			if( el.shadowRoot ) return true
			return super.skip_drag(el)
		}
		
	}
}
